export default (headers) => {
  return {
    pageCount: parseInt(headers['x-pagination-page-count'], 10),
    pageSize: parseInt(headers['x-pagination-per-page'], 10),
    currentPage: parseInt(headers['x-pagination-current-page'], 10),
    totalCount: parseInt(headers['x-pagination-total-count'], 10)
  }
}